import { Button } from "@peer-start/ui/reducate";
import { useTranslation } from "react-i18next";
import quizBadgeCheck from "../../../assets/starting-teacher/quiz-badge-check.svg?url";
import quizBadgeHelp from "../../../assets/starting-teacher/quiz-badge-help.svg?url";

export function StartingTeacherQuizBanner({
  percent,
  passed,
  onOpen,
}: {
  percent: number | undefined;
  passed: boolean;
  onOpen: () => void;
}) {
  const { t } = useTranslation();
  const failed = !passed && percent !== undefined;
  const score = passed ? 100 : percent;

  return (
    <div
      className={`flex items-center gap-[12px] rounded-[12px] border !border-[rgba(0,0,0,0.1)] p-[12px] ${passed ? "bg-success" : "bg-info"}`}
      data-control-id="starting-teacher.quiz.promo"
    >
      <span aria-hidden="true" className="grid size-[28px] shrink-0 place-items-center">
        <img alt="" height={24} src={passed ? quizBadgeCheck : quizBadgeHelp} width={24} />
      </span>
      <div className="flex min-w-0 flex-1 flex-col gap-[2px]">
        <div className="flex items-center gap-[6px]">
          <h2 className="text-[14px] leading-[20px] font-medium text-foreground">
            {t("startingTeacher.quizBanner.title")}
          </h2>
          {score !== undefined ? (
            <span
              className={`inline-flex h-[18px] items-center rounded-full px-[8px] text-[11px] leading-[16px] font-medium text-white ${passed ? "bg-[#62A000]" : "bg-link"}`}
            >
              {score}%
            </span>
          ) : null}
        </div>
        <p className="text-[12px] leading-[16px] text-secondary-text">{t("startingTeacher.quizBanner.body")}</p>
      </div>
      <Button
        className="!h-[28px] !min-h-[28px] !shrink-0 !rounded-[8px] !border-[rgba(0,0,0,0.1)] !bg-white !px-[10px] !py-0 !text-[12px] !leading-[16px] !font-medium !text-foreground !shadow-[0_1px_2px_rgba(0,0,0,0.1)] hover:!bg-white"
        controlId="starting-teacher.progress.quiz"
        onClick={onOpen}
        type="button"
        variant="secondary"
      >
        {t(
          passed
            ? "startingTeacher.quizBanner.view"
            : failed
              ? "startingTeacher.quizBanner.retry"
              : "startingTeacher.quizBanner.start",
        )}
      </Button>
    </div>
  );
}
